import { logger } from '../../../../../utils/common/logger'
import { LoginService } from '../services/login-service'
import { ILRWidgetOptions, LoginRadiusWidget, LRWidgetType } from './base'

export interface IWindow extends Window {
    social_lrobj: any
}

export interface ISuccessResponse {
    Profile: any,
    Data: any,
    access_token: string,
    jwttoken: string
}

declare let window: IWindow

export class SocialLoginWidget extends LoginRadiusWidget {

    private socialLogintemplate: string

    constructor(container: string, lrObject: any, template: string) {
        super()
        this.widgetType = LRWidgetType.SOCIAL_LOGIN
        this.lrObject = lrObject
        this.container = container
        this.socialLogintemplate = template

        logger('info', 'login widget created')
    }

    public initForm() {
        if (document.querySelector(`#${this.container}`)) {
            const widgetOptions = {
                container: this.container,
                onError: this.onError,
                onSuccess: this.onSuccess,
                templateName: this.socialLogintemplate
            } as ILRWidgetOptions

            this.lrObject.customInterface('.social-login-interface', widgetOptions)

            this.lrObject.init(this.widgetType, widgetOptions)
            window.social_lrobj = this.lrObject
        }
    }

    protected async onSuccess(response: ISuccessResponse) {
        logger('info', 'social-login-widget: Successfully logged in: ', response)
        LoginService.clearErrors()
        await LoginService.handleLoginSuccess(response)
    }

    protected onError(errors: any) {
        logger('error', 'social-login-widget: ', errors)
        LoginService.clearErrors()
        LoginService.showErrors(errors)
    }
}
